// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  font-size: 10px;
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  padding: 24px 0 12px;
  color: ${(props) => props.theme.colors.WHITE};

  @media ${(props) => props.theme.mediaQuery.large} {
    color: ${(props) => props.theme.colors.TEXT.DARKERGRAY};
  }

  p {
    margin: 0;
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${(props) =>
      props.isFooterRedesignEnabled &&
      `
    color: #000;
font-family: Nunito;
font-size: 10px;
font-style: normal;
font-weight: 400;
line-height: 150%; /* 15px */
padding-bottom: 2px;
    `}
  }
`;
